//import Cookies from "js-cookie";

import Map from "./components/map";
import Menu from "./components/menu";
import Schema from "./components/schema";
import Tabs from "./components/tabs";
import Modal from "./components/modal";
import OverlayView from "./components/overlayView";
import MultipleFileUpload from "./components/multipleFileUpload";
import claimSelections from "./components/claimSelections";
import select2 from "select2";
import NCookiePopup from './components/ncookie'

document.addEventListener("DOMContentLoaded", () => {

  new NCookiePopup();

  $('.js-dealer-map').select2({
    placeholder: "Indtast en by eller postnummer",
    language: {
      noResults: function noResults() {
        return 'Ingen resultater fundet';
      }
    }
  });

  if (document.getElementById('map-canvas')) {

    /**
     * Google Maps init
     */
    function initialize() {
      var myLatlng = new google.maps.LatLng(56.15, 11.5);

      var mapOptions = {
        zoom: 6.5,
        center: myLatlng,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        backgroundColor: '#fff',
        disableDefaultUI: true,
        draggable: false,
        scaleControl: false,
        scrollwheel: false,


        styles: [{
          "featureType": "water",
          "elementType": "geometry",
          "stylers": [{
            "visibility": "off"
          }]
        }, {
          "featureType": "landscape",
          "stylers": [{
            "visibility": "off"
          }]
        }, {
          "featureType": "road",
          "stylers": [{
            "visibility": "off"
          }]
        }, {
          "featureType": "administrative",
          "stylers": [{
            "visibility": "off"
          }]
        }, {
          "featureType": "poi",
          "stylers": [{
            "visibility": "off"
          }]
        }, {
          "featureType": "administrative",
          "stylers": [{
            "visibility": "off"
          }]
        }, {
          "elementType": "labels",
          "stylers": [{
            "visibility": "off"
          }]
        }, {}]
      };

      var googleMap = new google.maps.Map(document.getElementById('map-canvas'), mapOptions);

      var swBound = new google.maps.LatLng(54.55, 8.05);
      var neBound = new google.maps.LatLng(57.75, 15.15);
      var bounds = new google.maps.LatLngBounds(swBound, neBound);

      var srcImage = '/assets/images/svg/map.svg';


      new Map('map', 8600, new OverlayView(bounds, srcImage, googleMap));
    }

    google.maps.event.addDomListener(window, 'load', initialize);
  }

  if (document.getElementById('map-canvas-contact')) {

    /**
     * Google Maps init contact page
     */
    function initialize() {
      var myLatlng = new google.maps.LatLng(56.15, 11.5);

      var mapOptions = {
        zoom: 6.5,
        center: myLatlng,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        backgroundColor: '#fff',
        disableDefaultUI: true,
        draggable: false,
        scaleControl: false,
        scrollwheel: false,


        styles: [{
          "featureType": "water",
          "elementType": "geometry",
          "stylers": [{
            "visibility": "off"
          }]
        }, {
          "featureType": "landscape",
          "stylers": [{
            "visibility": "off"
          }]
        }, {
          "featureType": "road",
          "stylers": [{
            "visibility": "off"
          }]
        }, {
          "featureType": "administrative",
          "stylers": [{
            "visibility": "off"
          }]
        }, {
          "featureType": "poi",
          "stylers": [{
            "visibility": "off"
          }]
        }, {
          "featureType": "administrative",
          "stylers": [{
            "visibility": "off"
          }]
        }, {
          "elementType": "labels",
          "stylers": [{
            "visibility": "off"
          }]
        }, {}]
      };

      var googleMap = new google.maps.Map(document.getElementById('map-canvas-contact'), mapOptions);

      var swBound = new google.maps.LatLng(54.55, 8.05);
      var neBound = new google.maps.LatLng(57.75, 15.15);
      var bounds = new google.maps.LatLngBounds(swBound, neBound);

      var srcImage = '/assets/images/svg/map.svg';


      new Map('map', 2605, new OverlayView(bounds, srcImage, googleMap));
    }

    google.maps.event.addDomListener(window, 'load', initialize);
  }

  new Modal();
  new MultipleFileUpload();
  new claimSelections();

  new Menu('mainMenu')
  new Tabs('spareTab');
  new Tabs('tekniskeTab');
  new Tabs('productTab');
  new Schema('[data-toggle]').getTogglers();

  const header = document.querySelector(".header");
  const headerDiv = document.querySelector(".header div");
  const subMenus = document.querySelectorAll('.submenu');

  // Resize Sticky header
  let resizeHeight = 96;

  if (header) {
    document.addEventListener('scroll', (evt) => {
      if (document.body.scrollTop > resizeHeight || document.documentElement.scrollTop > resizeHeight) {
        // If we start resizing, change the resizeHeight, so it doesn't jump
        resizeHeight = 66;
        headerDiv.classList.add("xl:h-16")
        headerDiv.classList.remove("xl:h-24")

        subMenus.forEach((element) => {
          element.classList.remove('xl:mt-24')
          element.classList.add('xl:mt-16')
        })

      } else {
        resizeHeight = 96;
        headerDiv.classList.remove("xl:h-16");
        headerDiv.classList.add("xl:h-24")

        subMenus.forEach((element) => {
          element.classList.add('xl:mt-24')
          element.classList.remove('xl:mt-16')
        })
      }
    }, {
      capture: true,
      passive: true
    })
  }

  // Open/close search
  const searchButton = document.getElementById('searchButton');
  const closeSearchButton = document.getElementById('closeSearchButton');
  const body = document.querySelector('body');

  searchButton.addEventListener('click', () => {
    const searchMenu = document.getElementById('search-menu');
    searchMenu.classList.remove('hidden');
    body.classList.add('overflow-hidden');
  });

  closeSearchButton.addEventListener('click', () => {
    const searchMenu = document.getElementById('search-menu');
    searchMenu.classList.add('hidden');
    body.classList.remove('overflow-hidden');
  });


  // SelectBox
  const selectItems = document.getElementById('select-items');
  const selectBox = document.getElementById('select-box');

  if (selectBox !== null) {
    selectBox.addEventListener('click', () => {
      if (selectItems.classList.contains("hidden")) {
        selectItems.classList.add('block');
        selectItems.classList.remove('hidden');
      } else {
        selectItems.classList.add('hidden');
      }
    })
  }

  const selectMenu = document.querySelectorAll('.select-menu');
  const selectDrop = document.querySelectorAll('.select-item');

  selectMenu.forEach((element) => {
    element.addEventListener('click', () => {

    })
  });


  /**
   * Show/hide cookies
   */



 /* if (document.querySelector('#cookiePopup')) {
    function openCookiePopup() {
      document.querySelector('#cookiePopup').style.display = 'block';
    }

    function closeCookiePopup() {
      document.querySelector('#cookiePopup').style.display = 'none';

      if (!Cookies.get('cookiePopup')) {
        Cookies.set('cookiePopup', 'false', {
          expires: 90,
          path: ''
        });
      }
    }

    if (!Cookies.get('cookiePopup')) {
      openCookiePopup();
    }

    document.querySelector('#cookieButtonAccept').addEventListener('click', closeCookiePopup.bind());
    document.querySelector('#cookieButtonDeny').addEventListener('click', closeCookiePopup.bind());
  }*/




  /**
   * Show/hide notification
   */

  if (document.querySelector('#notificationPopup')) {
    function openNotificationPopup() {
      document.querySelector('#notificationPopup').style.display = 'block';
    }

    function closeNotificationPopup() {
      document.querySelector('#notificationPopup').style.display = 'none';

      if (!Cookies.get('notificationPopup')) {
        Cookies.set('notificationPopup', 'false', {
          expires: 1,
          path: '/'
        });
      }
    }

    if (!Cookies.get('notificationPopup')) {
      openNotificationPopup();
    }

    document.querySelector('#close-notify').addEventListener('click', closeNotificationPopup.bind());
  }

  /**
   * Umbraco forms automatic poppulate input field
   */

  const numpopfield = document.getElementById('num-pop-field');
  const submit = document.querySelector('.umbraco-forms-page');
  const input = document.querySelector('.fileElem');
  const frnums = document.querySelectorAll('.fr_num');
  for (const frnum of frnums) {
    submit.addEventListener('click', () => {
      numpopfield.value = "";
      setTimeout(function(){
      numpopfield.value += frnum.value;
      }, 500);
    });
    input.addEventListener('change', () => {
      numpopfield.value = "";
      setTimeout(function(){
        numpopfield.value += frnum.value;
      }, 500);
    });

    frnum.addEventListener('keyup', () => {
      if(frnum.nextElementSibling) {
        frnum.nextElementSibling.focus();
      }
    });

  }

})

/** Claim form loader */
$(document).ready(function() {
  $('.umbraco-forms-claimform .btn-primary').click(function() {
    if ($("span").hasClass("field-validation-error")) {
      $("body").removeClass("overlay");
      $(".claimLoader").remove();
    } else {
      $("body").addClass("overlay");
      $("body").prepend("<div class='claimLoader text-center text-white'><p><img class='ml-auto mr-auto' src='/assets/images/wait.gif' width='100px' height='100px' /></p></div>");
    }
  });
});

/** Case stories filter */
document.addEventListener("DOMContentLoaded", () => {
  const caseCheckboxes = document.querySelectorAll(".case-checkbox");
  const filterForm = document.getElementById("case-filter-form");
  if(filterForm) {
    for (const caseCheck of caseCheckboxes ) {
      caseCheck.addEventListener('change', () => {
        filterForm.submit();
      });
    }
  }
});

